import React, { FC } from 'react';

import GeneralLayout from 'core/react/layout/GeneralLayout';
import { TepClientsNotifications } from 'components/organisms/tep/clients-notifications';

export const TepClientsNotificationsPage: FC = () => (
  <GeneralLayout>
    <TepClientsNotifications />
  </GeneralLayout>
);
